import { Component, OnInit } from '@angular/core';
import { Path } from '@delon/theme';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-number-config',
  templateUrl: './d-number-config.component.html',
  styles: []
})
export class DNumberConfigComponent extends DynamicComponentBase {
  static KEY = 'd-number-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    // if (!Array.isArray(config.value)) {
    //   config.value = [];
    // }
  }
}
